module.exports = __webpack_public_path__ + "img/liyuzhe.2b8d22fe.jpg";